const selectors = {
  tabsNav: "[data-tabs-nav]",
  tabsBody: "[data-tabs-body]",
};

const tabsNavs = document.querySelectorAll(selectors.tabsNav);
const tabsBodies = document.querySelectorAll(selectors.tabsBody);

const selectSiblings = (container, selector, currentTarget, classToManipulate, remove) => {
  const items = container.querySelectorAll(selector);
  const allSiblings = [...items].filter((item) => item != currentTarget);
  if (remove) {
    allSiblings.forEach((sibling) => sibling.classList.remove(`${classToManipulate}`));
  } else {
    allSiblings.forEach((sibling) => sibling.classList.add(`${classToManipulate}`));
  }
};

if (tabsNavs) {
  tabsNavs.forEach((tabsNav, index) =>
    tabsNav.addEventListener("click", function (e) {
      if (!e.target.matches(".tabs__item")) {
        return;
      }

      const selectedTab = e.target;
      selectedTab.classList.add("is-current");

      selectSiblings(tabsNav, "li", selectedTab, "is-current", true);

      const selectedTabTarget = selectedTab.dataset.tabsNavIndex;
      const tab = tabsBodies[index].querySelector(`[data-tabs-products-index="${selectedTabTarget}"]`);
      tab.classList.remove("is-invisible");

      selectSiblings(tabsBodies[index], ".js-tab-products", tab, "is-invisible", false);
    })
  );
}
